import {Box, Heading, Text} from '@miro-site/core'
import React from 'react'
import styled from 'styled-components'

export type FaqItem = {
  question: string
  answer: string
}

export interface FaqItemsProps {
  title: string
  items: FaqItem[]
}

const FaqItem = styled(Box).attrs({
  $mb: 24,
})`
  &:last-child {
    margin-bottom: 0;
  }
`

const Question = styled(Text).attrs({
  $styles: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 26,
    marginBottom: 8,
  },
})({})

const Answer = styled(Text).attrs({
  $styles: {
    fontSize: 18,
    lineHeight: 26,
  },
})({})

const FaqItems: React.FC<FaqItemsProps> = ({title, items}) => {
  return (
    <Box $mt={[40, 60, 60, 60]}>
      <Heading $variant="h3" $mb={24}>
        {title}
      </Heading>
      {items.map(item => (
        <FaqItem key={item.question}>
          <Question as="h3">{item.question}</Question>
          <Answer>{item.answer}</Answer>
        </FaqItem>
      ))}
    </Box>
  )
}

export default FaqItems
